import {
    withDevtools,
    withRedux,
    withStorageSync,
} from '@angular-architects/ngrx-toolkit';
import { Injectable } from '@angular/core';
import { APP_STORE_INITIAL_STATE, AppStoreState } from '@app/stores/app/app.state';
import { signalStore, withState } from '@ngrx/signals';
import { appActions as actions } from './app.action';
import { appEffects as effects } from './app.effect';
import { appReducer as reducer } from './app.reducer';
import { decrypt, encrypt } from '@app/helpers/crypto/crypto-helper';
import { environment } from '@env/environment';

@Injectable({
    providedIn: 'root',
})
export class AppStore extends signalStore(
    withStorageSync({
        key: environment.appStoreKey,
        parse: (state: string) => {
            try {
                return JSON.parse(decrypt(environment.salt, state)) as AppStoreState;
            } catch {
                return APP_STORE_INITIAL_STATE;
            }
        },
        stringify: (state: unknown) => encrypt(environment.salt, JSON.stringify(state)),
        storage: () => sessionStorage,
    }),
    withState<AppStoreState>(APP_STORE_INITIAL_STATE),
    withDevtools('RCP App Store'),
    withRedux({
        actions,
        reducer,
        effects,
    }),
) {}
